import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { Editor } from 'ngx-editor';
import { Subscription } from 'rxjs';
@AutoUnsubscribe()
@Component({
  selector: 'ngx-editor-field',
  templateUrl: './ngx-editor-field.component.html',
  styleUrls: ['./ngx-editor-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxEditorFieldComponent implements OnInit, OnDestroy {
  @Input() arrayItem;
  @Input() requiredSaveEditButton = false;
  @Input() saveValueInDb;
  showEditorMenu = false;
  @Input() formControlName;
  @Input() previousEditorData;
  @Input() showToggle = false;
  @Input() itemsToSetup;
  isBlueEditor = false;
  @Input() mode;
  @Input() formControlValue = '';
  setPreviousValue;
  @Output() parentFun: EventEmitter<any> = new EventEmitter();
  @Output() bookTitleCreated = new EventEmitter<any>();
  @Output() saveDescription: EventEmitter<any> = new EventEmitter<any>();
  subscription = new Subscription();
  editor: Editor;
  placeHolderText = '';
  name = new FormControl('');
  toolbar = [
    ['bold', 'italic'],
    ['ordered_list', 'bullet_list'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  constructor(private cd: ChangeDetectorRef) {}

  onChange(item) {
    this.saveDescription.emit({ item });
  }
  changeBlueEditor() {
    this.isBlueEditor = true;
    this.cd.detectChanges();
  }
  ngOnInit(): void {
    try {
      if (this.arrayItem?.placeholder) {
        this.placeHolderText = this.arrayItem?.placeholder.replaceAll('#0x0a', '<br/>');
      }
      this.formControlName = this.arrayItem.formControlName;
      if (this.formControlValue !== '') {
        this.setPreviousValue = this.formControlValue;
        this.name.setValue(this.formControlValue);
      } else {
        this.name.setValue(this.placeHolderText);
      }
      this.editor = new Editor();
      this.subscription.add(
        this.name.valueChanges.subscribe((value) => {
          if (value === '<p></p>' || value === '') {
            // this.name.setValue(this.placeHolderText);
          } else {
            if (value === '<p></p>' || value === '') {
              this.name.setValue(this.placeHolderText);
            } else {
              this.setPreviousValue = value;
              this.bookTitleCreated.emit({
                formControlName: this.formControlName,
                value: this.setPreviousValue,
              });
            }
          }
        })
      );
    } catch (error) {
      console.error(error);
    }
    if (this.mode !== 'view') {
      this.showEditorMenu = true;
      this.cd.detectChanges();
    }
  }
  save(value) {
    this.isBlueEditor = false;
    if (this.isBlueEditor || (this.requiredSaveEditButton && this.saveValueInDb !== this.formControlValue)) {
      this.saveDescription.emit({ item: 'descriptionSection' });
    }

    this.parentFun.emit({ value });
  }

  onEditDescription() {
    if (this.mode !== 'view') {
      this.showEditorMenu = true;
      this.cd.detectChanges();
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
